import { useQuery } from '@apollo/client';
import React, { useState } from 'react';
import { Outlet } from 'react-router';
import * as styles from './ExtensionApp.module.scss';
import { SessionActions } from '../../account/sessionSlice';
import { gql } from '../../graphql/generated';
import { IsExtensionProvider } from '../../utils/useIsExtension';
import { useAppDispatch } from '../redux/useAppSelector';

const EXTENSION_SESSION_QUERY = gql(/** @complexity 16 */ `
  query extensionSession {
    currentSession {
      ...startSession_session
    }
  }
`);

const ExtensionApp = () => {
  const dispatch = useAppDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [theme] = useState<'dark' | 'light'>(() =>
    new URLSearchParams(window.location.search).get('theme') === 'dark'
      ? 'dark'
      : 'light',
  );

  useQuery(EXTENSION_SESSION_QUERY, {
    onCompleted(data) {
      dispatch(SessionActions.startSession(data.currentSession));
      setIsAuthenticated(true);
    },
  });

  return (
    <IsExtensionProvider>
      <div data-theme={theme} className={styles.container}>
        {isAuthenticated && <Outlet />}
      </div>
    </IsExtensionProvider>
  );
};

export default ExtensionApp;
